import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    monitoringMode: 'live',
    selectedCategory: 'module'
};

const appSlice = createSlice({
    name: 'app',
    initialState: initialState,
    reducers: {
        setMonitoringMode(state, action) {
            state.monitoringMode = action.payload.monitoringMode;
        },
        setSelectedCategory(state, action) {
            state.selectedCategory = action.payload.selectedCategory;
        }
    }
});

export const { setMonitoringMode, setSelectedCategory } = appSlice.actions;

export default appSlice.reducer;
